import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import { logout } from "../../redux/slices/authSlice";

const PrivateRoute = ({ children, allowedRoles = [] }) => {
  const dispatch = useDispatch();
  const { user, token } = useSelector((state) => state.auth);

  // Check if token exists in localStorage (source of truth)
  const localStorageToken = localStorage.getItem("authToken");
  const localStorageUser = localStorage.getItem("user");

  // If token is missing from localStorage but exists in Redux, clear Redux state
  useEffect(() => {
    if (!localStorageToken && token) {
      dispatch(logout());
    }
  }, [localStorageToken, token, dispatch]);

  // Check authentication - use localStorage as source of truth
  if (!localStorageToken || !localStorageUser) {
    // Clear Redux state if it still has values
    if (token || user) {
      dispatch(logout());
    }
    return <Navigate to="/login" replace />;
  }

  // Parse user from localStorage if Redux doesn't have it
  let currentUser = user;
  if (!currentUser && localStorageUser) {
    try {
      currentUser = JSON.parse(localStorageUser);
    } catch (e) {
      // Invalid user data, logout
      dispatch(logout());
      return <Navigate to="/login" replace />;
    }
  }

  // Check if user exists
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Check role-based access
  if (allowedRoles.length > 0 && !allowedRoles.includes(currentUser.user_type)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PrivateRoute;
